<template>
    <v-row class="flex-grow-1 py-4 align-items-center justify-content-center">
        <v-column cols="12" md="5">
            <h4 class="mb-4">
                <b>Send {{ page.coach.account.full_name }} a message</b>
            </h4>
            <contact-form
                :context="`Client interested in working with ${page.coach.account.full_name}: `"
            />
        </v-column>
    </v-row>
</template>

<script>
import ContactForm from "@/components/ContactForm";

export default {
    name: "CoachContactView",
    components: {
        ContactForm
    },
    props: ["page", "context"]
};
</script>